import React from 'react';
import Helmet from 'react-helmet';
import { Link } from '@reach/router';

import Navigation from '../../components/WaveNavigation/';
import Island from '../../components/Island/';
import Instagram from '../../components/Cards/instagram';
import PageHeader from '../../components/PageHeader';
import Amenities from '../../utils/amenities';
import Tip from '../../components/Tips';

import fiferries from '../../assets/img/instagram/profiles/fiferries.jpg';
import instagram from './images/replaceME.jpg';

export default () => (
  <div>
    <Helmet
      title='Fire Island Ferries | Ocean Bay Park'
      meta={[
        {
          name: 'description',
          content:
            'Ocean Bay Park is a lively community on Fire Island featuring restaurants and hotels.',
        },
        {
          name: 'keywords',
          content:
            'Ocean Bay Park, Fire Island, New York, Long Island, Ferries, Water Taxi',
        },
      ]}
    />
    <Navigation />
    <div className='container p-0'>
      <PageHeader beach='Ocean Bay Park'>
        <h2>Communities</h2>
        <h1>Ocean Bay Park</h1>
        <p>Amenities</p>
        <div className='amenities'>
          {Amenities.byBeach('Ocean Bay Park').map((item) => (
            <i
              key={item.text}
              className={`icon-${item.icon}`}
              title={item.text}
            />
          ))}
        </div>
        <div>
          <Link
            className='btn btn-outline-light'
            to='/schedules/ocean-bay-park'
          >
            Schedules
          </Link>
          &nbsp;&nbsp;
          <Link className='btn btn-outline-light' to='/directory'>
            Directory
          </Link>
        </div>
      </PageHeader>
    </div>
    <div className='container page'>
      <div className='row'>
        <div className='col-xl'>
          <div className='heading'>
            <h1>About Ocean Bay Park</h1>
          </div>
          <p>
            Ocean Bay Park is a lively community consisting of bar/restaurants,
            hotel accomodations, beautiful beaches, and more. Come rent a bike
            to explore even more of the island.
          </p>
        </div>
        {/* <div className="col-xl-4">
          <Instagram account="fiferries" datestamp="June 23, 2016" profile={fiferries} image={instagram} link="https://www.instagram.com/fiferries" className="mx-auto" />
        </div> */}
      </div>
      <Tip title="Captain's Tip">
        When returning on the ferry be sure to hand your blue valet ticket to a
        deckhand so your car will be waiting for you when you disembark.
      </Tip>
      <h1>Transportation</h1>
      <p>
        Ferry service to and from Ocean Bay Park is available by Fire Island
        Ferries from Bay Shore.{' '}
        <Link to='/schedules/ocean-bay-park'>Click here for schedules.</Link>
      </p>
      <p>
        <a href='http://www.fireislandwatertaxi.com'>Water Taxi</a> service is
        available to and from Ocean Bay Park during in-season operation.
      </p>
      <Island />
    </div>
  </div>
);
